import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';

const Backdrop = ({
  children,
  onClick,
  className = null,
  hasCloser = false,
}) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClick();
      }
    };

    window.addEventListener('keydown', handleEscape);
    document.body.classList.add('no_scroll');

    return () => {
      window.removeEventListener('keydown', handleEscape);
      document.body.classList.remove('no_scroll');
    };
  }, [onClick]);

  const handleClick = (e) => {
    if (e.target === e.currentTarget) {
      onClick();
    }
  };
  const btnClose = () => {
    onClick();
  };

  return (
    <motion.div
      className={`${
        className
          ? className
          : 'fixed inset-0 z-[7000] max-h-screen w-full flex justify-center items-center overflow-y-auto sm:p-5 bg-black/90'
      }`}
      onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {hasCloser && (
        <div
          className="absolute z-[8000] top-5 right-5 sm:right-10  text-white cursor-pointer flex p-2 rounded-full hover:scale-110 bg-slate-400/40"
          onClick={btnClose}
        >
          <CloseIcon />
        </div>
      )}
      {children}
    </motion.div>
  );
};

export default Backdrop;
